<template>
  <div class="i-main-content">

    <!--面包屑-->
    <el-breadcrumb separator="/">
      <el-breadcrumb-item :to="{ path: '/' }">Home</el-breadcrumb-item>
      <el-breadcrumb-item>Enterprise List</el-breadcrumb-item>
    </el-breadcrumb>

    <!--搜索-->
    <search-wrapper>
      <el-select v-model="searchFieldName" placeholder="Query Type" class="block">
        <el-option
          v-for="item in searchFieldOptions"
          :key="item.value"
          :label="item.label"
          :value="item.value">
        </el-option>
      </el-select>
      <el-input v-model="searchText" placeholder="Query Text" prefix-icon="el-icon-search"
       class="block" clearable></el-input>
      <el-button @click="queryHandle" type="primary" :disabled="tableLoading">Query</el-button>
      <space></space>
      <el-button @click="addHandle" type="" v-if="loginInfo && loginInfo.UserType==0">Add</el-button>
      <el-button @click="deleteHandle" type="" v-if="loginInfo && loginInfo.UserType==0">Delete</el-button>
    </search-wrapper>

    <!--表格-->
    <el-table ref="multipleTable" :data="tableData" tooltip-effect="dark" style="width: 100%"
      @selection-change="val => multipleSelection=val" v-loading="tableLoading" >
      <el-table-column type="selection" width="55" :selectable="selectableHandle"></el-table-column>
      <el-table-column label="Enterprise" width="200">
        <div class="i-link" slot-scope="scope" @click.stop="rowClick(scope.row)">{{ scope.row.Enterprise1 }}</div>
      </el-table-column>
      <el-table-column label="ContactName" prop="ContactName" width="250" :formatter="emptyFormat">
        <!-- <template slot-scope="scope">{{ scope.row.ContactName }}</template> -->
      </el-table-column>
      <el-table-column label="ContactNo" prop="ContactNo" width="150" :formatter="emptyFormat"></el-table-column>
      <el-table-column label="Email" prop="Email" width="250" :formatter="emptyFormat"></el-table-column>
      <el-table-column label="Administrator" prop="LoginName"></el-table-column>
    </el-table>
    <el-pagination class="i-main-pager imt-2" background layout="total, prev, pager, next, jumper" :total="pageTotalCount"
      @current-change="pageCurrentChange"></el-pagination>

    <!--Dialog-->
    <el-dialog title="Info" :visible.sync="dialogVisible" @close="dislogClosed">
      <el-form :model="form" :rules="rules" ref="NewForm" label-position="left" label-width="120px">
        <el-form-item label="Enterprise" prop="Enterprise1">
          <el-input v-model="form.Enterprise1" auto-complete="off" :disabled="self"></el-input>
        </el-form-item>
        <el-form-item label="Administrator" prop="LoginName">
          <el-input v-model="form.LoginName" auto-complete="off" :disabled="self"></el-input>
        </el-form-item>
        <el-form-item label="Password" prop="PSWD">
          <el-input v-model="form.PSWD" type="password" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="ContactName" prop="ContactName" >
          <el-input v-model="form.ContactName" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="ContactNo" prop="ContactNo" >
          <el-input v-model="form.ContactNo" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="Email" prop="Email">
          <el-input v-model="form.Email" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="Fun">
          <tree-select :datas="funSelect.data" v-model="funSelect.visible" class="block" :loading="funSelect.loading" top
            :defaultCheckedRows="funSelect.checked" @check="funSelectCheck" :props="funSelect.props"
            :panel-height="300" show-check-all check-strictly>
            <el-input v-model="funSelect.text" placeholder="Select Fun" slot="active" @focus="funSelect.visible=true" :disabled="self" readonly></el-input>
          </tree-select>
          <!-- <el-input v-model="form.FunIds" auto-complete="off" :disabled="self"></el-input> -->
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="okHandle" :loading="dialogOkButtonLoading">OK</el-button>
          <el-button @click="dialogVisible = false" :disabled="false">Cancel</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
//import {getToken} from '@/common/auth'
import searchWrapper from '@/components/search-wrapper'
import funSelect from '@/views/mixins/fun-select'
import searchCommon from '@/views/mixins/search-common'
import {deleteFromArray} from '@/common/utils'
import {mapGetters} from 'vuex'
import {Filter, Op} from '@/api/config'
import * as API from '@/api/enterprise'
import { searchFieldOptions, searchFieldOperation } from './options'
import tableColumnFormat from '@/views/mixins/table-column-format'
import TreeSelect from '@/components/tree-select'
import { resolve } from 'url';
import { EHOSTUNREACH } from 'constants';

export default {
  name: 'company',
  data() {
      return {
        // Dialog
        // clickedRow: {},
        dialogVisible: false,
        form: {},

        // Search
        searchFieldName: '', // 查找字段名
        searchFieldOptions, // 查找备选项
        searchFieldOperation, // 查找字段对应操作
        searchText: '', // 查找关键字

        // Table
        tableData: [],

        multipleSelection: [], // 选中行数据

        // 验证规则
        rules: {
          Enterprise1: [
            { required: true, message: 'Enterprise is required', trigger: 'blur' },
            { min: 3, max: 40, message: 'Enterprise must be between 3 and 40 characters', trigger: 'blur' }
          ],
          ContactName: [
            { min: 3, max: 20, trigger: 'blur' }
          ],
          ContactNo: [
            { min: 3, max: 20, trigger: 'blur' }
          ],
          Email: [
            { pattern: /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/, message: 'Please enter a valid email address or leave the field blank' },
            { min: 3, max: 20, trigger: 'blur' }
          ],
          LoginName: [
            { required: true, trigger: 'blur' },
            { min: 3, max: 20, trigger: 'blur' }
          ],
          PSWD: [
            { required: true, message: 'Password is required', trigger: 'blur' },
            { min: 3, max: 15, trigger: 'blur' }
          ]
        }
      }
  },
  computed: {
    ...mapGetters([
      'userId',
      'loginInfo'
    ]),
    self() {
      return this.form.EID == this.loginInfo.EID
    }
  },
  created() {
    this.queryHandle()
  },
  methods: {
    // 表格行点击事件
    rowClick(row) {
      this.form = Object.assign({}, row)
      this.funSelectSetChecked(row.UserID)
      this.dialogVisible = true
    },

    // 新增事件
    addHandle() {
      this.form = {newLine: true}
      this.funSelectSetChecked(-1)
      this.dialogVisible = true
    },

    // 删除事件
    deleteHandle() {
      const targetRows = this.$refs.multipleTable.selection

      if (targetRows.length <= 0) {
        this.$alert('You must select at least one item.', '', {
          type: 'error'
        })
        return
      }

      this.$confirm('This item will be permanently deleted ?', 'Warning', {
        confirmButtonText: 'Confirm',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(() => {

        this.deleteButtonLoading = true
        API.Delete(targetRows.map(k => k.EID)).then(ret => {
          // 从本地删除
          // targetRows.forEach(item => {
          //   deleteFromArray(this.tableData, row => {
          //     return row == item
          //   })
          // })

          this.$message({
            type: 'success',
            message: 'Success!',
            showClose: true
          });

          if ((targetRows.length < this.pageSize)
            && (targetRows.length < this.tableData.length)) {
            this.pageIndex = this.pageIndex > 1 ? this.pageIndex - 1 : 1
          }
          
          this.queryHandle()

        }).catch(err => {
          this.print('error', err.message)
        })

      }).catch(() => {
      });



    },

    // 弹出框验证
    okHandleValidate() {
      const promise = new Promise((resolve, reject) => {
        this.$refs.NewForm.validate(valid => {
          if (valid) {
            resolve(true)
          } else {
            reject(false)
          }
        })
      })


      return promise
    },

    // 弹出页确认事件
    async okHandle() {
      let valid
      try {
        valid = await this.okHandleValidate()
      } catch (e) {
        valid = false
      }

      if (!valid) {
        return
      }

      const funs = this.funSelect.checked.map(i=>i.value)
      // const halfFuns = this.funSelect.halfChecked.map(i => i.value)
      // funs = funs.concact(halfFuns)

      this.dialogOkButtonLoading = true
      if (!this.form.EID) {
        // Add
        API.Add(this.form.Enterprise1,
          this.form.ContactName,
          this.form.ContactNo,
          this.form.Email,
          this.form.LoginName,
          this.form.PSWD,
          funs).then(ret => {

            if (!ret.data.errCode) {
              this.queryHandle().then(() => {
                this.dialogVisible = false
                this.dialogOkButtonLoading = false
              }).catch(() => {
                this.dialogVisible = false
                this.dialogOkButtonLoading = false
              })
            } else {
              // 错误
              this.print('error', ret.data.errMsg)
              this.dialogVisible = false
              this.dialogOkButtonLoading = false
            }

        }).catch(err => {
          // 错误
          this.print('error', err.message)
          this.dialogVisible = false
          this.dialogOkButtonLoading = false
        })

      } else {
        // Modify

        API.Modify(this.form.EID,
          this.form.Enterprise1,
          this.form.ContactName,
          this.form.ContactNo,
          this.form.Email,
          this.form.LoginName,
          this.form.PSWD,
          funs).then(ret => {

            if (!ret.data.errCode) {
              this.queryHandle().then(() => {
                this.dialogVisible = false
                this.dialogOkButtonLoading = false
              }).catch(() => {
                this.dialogVisible = false
                this.dialogOkButtonLoading = false
              })

            } else {
              // 错误
              this.print('error', ret.data.errMsg)
              this.dialogVisible = false
              this.dialogOkButtonLoading = false
            }

          }).catch(err => {
            // 错误
            this.print('error', err.message)
            this.dialogVisible = false
            this.dialogOkButtonLoading = false
        })
      }


    },

    // 查询事件
    queryHandle() {

      const promise = new Promise((resolve, reject) => {
        const filters = []
        this.searchText.length > 0
          && (filters.push(new Filter(this.searchFieldName, this.searchText, Op.Contains)))

        this.tableLoading = true

        API.Query(this.pageIndex, this.pageSize, this.sortKey, this.sortDirect, filters).then(ret => {
          this.tableData = ret.data.list.slice()
          this.pageTotalCount = ret.data.total
          this.tableLoading = false
          resolve()
        }).catch(err => {
          this.print('error', err.message)
          this.tableLoading = false
          reject(err)
        })
      })

      return promise
    },

    // 行是否可以选中
    selectableHandle(row) {
      return row.EID != this.loginInfo.EID
    },

    // 反选表格
    toggleSelection(rows) {
      if (rows) {
        rows.forEach(row => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },

    dislogClosed() {
      this.$refs.NewForm && this.$refs.NewForm.clearValidate()
    }
  },
  components: {
    searchWrapper,
    TreeSelect
  },
  mixins: [searchCommon, tableColumnFormat, funSelect]
}
</script>

<style lang="scss" scoped>
.i-main-content {
  & .el-form {
    width: 460px;
    margin: 0 auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/company/company.vue